/**
 * @fileoverview Agent definition for the short-story-extractor primitive.
 *
 * Unified extraction agent for short-form fiction. Combines plot extraction
 * (summary + writtenPlot) and chapter metadata extraction (scenes, pacing,
 * goals, POV) into a single pass.
 *
 * Mirrors the planning-side consolidation in short-story-planner-v4.
 * Replaces the two-agent pipeline of plot-extractor-v2 + single-chapter-extractor-v2
 * for short-form imports.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'short-story-extractor',
  kind: 'primitive',
  name: 'Story Extractor (Short-Form)',
  description:
    'Extracts plot structure and chapter metadata from short-form fiction in a single pass. ' +
    'Combines summary, writtenPlot, scenes, pacing, goals, and POV extraction.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['ImportPage', 'use-short-form-import.ts'],
    relatedAgents: ['short-story-planner-v4', 'plot-extractor-v2', 'single-chapter-extractor-v2'],
  },
};
